import React, {Component, Fragment, useState, useEffect, useContext} from "react";
import {Link} from "react-router-dom";
import cookie from "react-cookies";
import {CSSTransition} from "react-transition-group";
import {PropTypes} from 'prop-types';

import {Button} from "./common/common";
import {toggleState, relativePath, } from "../lib/tools";
import {LoginModal, Modal, PromptModal} from "./common/modal";
import {FormInput, ValidateForm} from "./common/formValidation";
import {reduxWrapper} from "../globalState";
import {ModalContext} from './../contexts';
import { mapObjectToArray } from './../lib/tools';
import { MobileView, BrowserView } from "react-device-detect";

// Icons
import CloseIcon from "../resources/icons/x-grey.png";
import ShareIcon from "../resources/icons/share.svg";
import dropArrowIcon from "../resources/icons/arrow-grey.png";
import foodIcon from "../resources/icons/mad.png";
import drinkIcon from "../resources/icons/drikke.png";
import decoIcon from "../resources/icons/dekoration.png";
import atmoIcon from "../resources/icons/stemning.png";
import extraIcon from "../resources/icons/Ekstra.png";
import pracIcon from "../resources/icons/Praktisk.png";
import bundleIcon from "../resources/icons/Praktisk.png";
import userIcon from "../resources/icons/user-green.png";
import logoDarkGreenIcon from "../resources/icons/logo-dark-green.svg";
import userDarkGreenIcon from "../resources/icons/user-dark-green.svg";
import { getImage } from "../lib/api";

// New header added 17.06.2019
const PartyInfoHeaderRender = ({sections}) => {
	const [chosenSection, setChosenSection] = useState(null);
	const [openNav, setOpenNav] = useState(false);

	useEffect(() => {
		//console.log(sections);
	})

	return(
		<header 
			className="infoHeaderWrapper"
			onMouseLeave={() => {
				setOpenNav(false);
				setTimeout(() => {
					setChosenSection(null);
				}, 500)}
			}
		>
			<div className="topWrapper">
				<Link to="/">
					<img src={logoDarkGreenIcon} alt="Logo"/>
				</Link>
				<MobileView renderWithFragment>
					<h1>Tilføj</h1>
				</MobileView>
				<BrowserView renderWithFragment>
					<div className="sectionNav">
						{mapObjectToArray(sections, (x, i) => 
							<div 
								key={i} 
								onMouseEnter={() => {setChosenSection(i); setOpenNav(true);}}
							>
								{x.title}
							</div>
						)}
					</div>
				</BrowserView>
				<img src={userDarkGreenIcon} alt="Bruger"/>
			</div>
			<CSSTransition
				classNames="subSectionWrapper"
				timeout={500}
				in={openNav}
				unmountOnExit
			>
				<div className="subSectionWrapper">
					{ chosenSection && 
						sections[chosenSection].children.map((x,i) => 
							<Link to={`/minfest/${x.vanity}`} className="subSection" key={i}>
								<div className="imgWrapper">
									<img src={getImage(x.image)} alt={x.title}/>
								</div>
								{x.title}
							</Link>
						)
					}
				</div>
			</CSSTransition>
		</header>
	)
};

export const PartyInfoHeader = reduxWrapper(
	"loadPartyInfo",
	"setPartyInfo",
	"loadSections"
)(PartyInfoHeaderRender);

PartyInfoHeaderRender.propTypes = {
	partyInfo: PropTypes.object,
	setPartyInfo: PropTypes.func
}




//New Design
//<editor-fold desc="Header">
class HeaderRender extends Component {
	state = {
		showPartyInfo: false,
		partyName: null,
		partyGuests: null
	};

	onToggle = (name, val) => {
		this.setState(toggleState(name, val));
	};

	render() {
		const {error} = this.props;

		if (error)
			this.error = error;

		return (
			<header id="header">

				<div className="headerWrapper">
					<div className="headerTop">
						<Link className="logo black" to={"/"}/>
						<BurgerNav black/>
					</div>
				</div>

				<CSSTransition 
					classNames="darkBg" 
					timeout={500}
					in={this.state.showPartyInfo} 
					unmountOnExit
				>
					<div className="darkBg" onClick={() => this.onToggle("showPartyInfo", false)}/>
				</CSSTransition>
				{
					error != null &&
					<div className="errorMessage">{this.error}</div>
				}
			</header>
		)
	}
}
export const Header = reduxWrapper(
	"getApiCall", 
	"loadError", 
	"loadPartyInfo", 
	"getPartyExists"
)(HeaderRender);

export class BannerHeader extends Component {
	render(){
		const {children, bgImage, className} = this.props;
		const style = {	backgroundImage: `linear-gradient(to bottom, rgba(41, 93, 97, 0.6), rgba(41, 93, 97, 0.6)), 
																			linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.9)), 
																			url(${bgImage})`
									}
		return(
			<header id="bannerHeader" className={className ? className : ""} style={bgImage ? style : null}>
				<SimpleHeader/>
				<div className="bannerHeaderContent">
					{children}
				</div>
			</header>
		)
	}
}

const SimpleHeaderRender = ({className, black}) => {
	return (
		<header id="simpleHeader" className={className}>
			<BurgerNav/>
			<Link to={"/"} className="logo white"/>
			<HeaderProfile black={black}/>
	</header>
	);
};
export const SimpleHeader = reduxWrapper("getUserId", "getApiCall")(SimpleHeaderRender);

const BurgerNavRender = ({userId, logOut, black, sections}) => {
	const [show, setShow] = useState(false);
	return (
		<Fragment>
			<div className={["burgerIcon", black ? "black" : "white"].join(" ")} onClick={() => setShow(true)}/>
			<CSSTransition
				classNames="burgerNav"
				timeout={500}
				in={show}
				unmountOnExit
			>
				<div className="burgerNav">
					
					<div className="burgerNavTop">
						<img className="close" src={CloseIcon} onClick={() => setShow(false)} alt="Luk"/>
					</div>
					
					<div className="burgerNavLinks">
						{userId && 
							<Link to="/mine-sider/profil" className="profileLinkWrapper sectionLinkText">
								<img src={userIcon} alt="Din profil" />
								Din Profil
							</Link>
						}
						<ul>
							{
								mapObjectToArray(sections, (tile, i) => 
									<BurgerNavElement tile={tile} key={i}/>
								)
							}
						</ul>
						<ul>
							<li>
								<div className="sectionTitle">
									<img src={bundleIcon} alt="Pakker"/>
									<Link to={"/pakker"} className="sectionTitle sectionLinkText">Gydeklare fester</Link>
								</div>
							</li>
						</ul>

						{/* <ul>
							<li>
								<div className="sectionTitle">
									<Link className="sectionTitle sectionLinkText" to="/konkurrence">Konkurrence</Link>
								</div>
							</li>
						</ul> */}

						{userId &&
							<ul className="isLoggedIn">
								<li><div className="sectionLinkText sectionLogOut ga-logOut" onClick={() => {logOut(); setShow(false);}}>Log ud</div></li>
							</ul>
						}
					</div>
				</div>
			</CSSTransition>
		</Fragment>
	);
};
export const BurgerNav = reduxWrapper("getLogOut", "getUserId", "getApiCall", "loadSections")(BurgerNavRender);

const BurgerNavElement = ({tile}) => {

	const [expand, setExpand] = useState(false);
	const icons = {
		food: foodIcon,
		drinks: drinkIcon,
		decorations: decoIcon,
		atmosphere: atmoIcon,
		extra: extraIcon,
		practical: pracIcon
	}

	return (
		<li className={expand ? "expand" : ""} onClick={() => setExpand(!expand)}>
			<div className="sectionTitle sectionLinkText">
				<img src={icons[tile.code]} alt={tile.title}/>
				{tile.title} 
				<img src={dropArrowIcon} alt="Drop down" style={{transform: expand ? "rotate(270deg)" : "rotate(90deg)"}}/>
			</div>
			<ul>
				{ tile.children.map(x => 
						<li key={x.id}>
							<Link to={`/minfest/${x.vanity}`} className="sectionLinkText">
								{x.title}
							</Link>
						</li>
					)	
				}
			</ul>
		</li>
	)
};

class HeaderProfileRender extends Component {
	static contextType = ModalContext;

	prompt = {
		text: "Er du sikker du vil logge ud?",
		confirm: () => {
			this.props.logOut(); 
			this.context.toggleModal(false);
		},
		decline: () => {
			this.context.toggleModal(false);
		},
		confirmText: "Ja",
		declineText: "Nej"
	}

	render(){
		const {userId} = this.props;
		return(
			<div 
				className="userProfile" 
				onClick={userId ? 
					() => this.context.toggleModal(true, <PromptModal {...this.prompt}/>) : 
					() => this.context.toggleModal(true, <LoginModal/>)
				}
			>
				<span>{ userId ? "LOG UD" : "LOG IND" }</span>
			</div>
		)
	}
}

export const HeaderProfile = reduxWrapper("getUserId", "getLogOut")(HeaderProfileRender);

export class CookieWindow extends Component {
	state = {
		showCookies: false
	}

	acceptCookies() {
		cookie.save("cookiesAccepted", "This_little_thing_tells_us_that_you_accepted_our_cookie_policy!", {path: "/"});
		this.setState({showCookies: false});
	}

	componentDidMount(){
		if(!cookie.load("cookiesAccepted")){
			this.setState({
				showCookies: true
			});
		}
	}

	render(){
		return(
			<Fragment>
				{this.state.showCookies &&
					<div className="cookieWindow cookieContainer">
						<span>
							Vi bruger cookies for at forbedre din oplevelse. Læs hvordan <Link to="/info/cookies">her</Link>
						</span>
						<Button onClick={() => this.acceptCookies()}>OK</Button>
					</div>
				}
			</Fragment>
		)
	}
}
//<editor-fold desc="Party Info">

//View to invite people to access your party.
export class InviteView extends Component {
	constructor(props) {
		super(props);
		this.state = {email: ""};

		this.onSubmit = val => {
			const email = val.email;
			this.props.apiCall("POST", `/party/current/invite`, data => {
				this.setState({email: email});
			}, {email: email})
		}
	}

	render() {
		return (
			<Modal onHide={this.props.onHide} className="sharePartyModal" icon={ShareIcon} title="DEL DIN FEST">
				<span>
					Ved at dele din fest med andre, får de mulighed for at se din planlægning af festen.  
				</span>
				<ValidateForm clear onSubmit={this.onSubmit}>
					<FormInput value={this.state.email} name="email" type="email" rules="email" req={true}
					           onChange={val => this.setState({email: val})}/>
					{
						this.state.email ? <span>E-mail sent til {this.state.email}</span> : null
					}
					<Button className="btnGreen" submit>DEL MIN FEST</Button>
				</ValidateForm>
				<a target="_blank" href={this.state.link}>{this.state.link}</a>
			</Modal>
		);
	}
}

class SmartLoginRender extends React.Component {
	
	componentWillMount() {
		this.props.emailLogin({data: {hash: this.props.hash}}).then(() => this.props.history.push("/login/first"));
	}
	
	render() {
		return null;
	}
}

export const SmartLogin = reduxWrapper("getEmailLogin")(SmartLoginRender);

class FirstLoginRender extends React.Component {
	
	static contextType = ModalContext;
	
	submit = (data) => {
		this.props.apiCall("POST", "register/password/new", () => this.props.history.replace("/minfest"), data, error => alert(error))
	};
	
	render(){
		return(
			<Modal className="setPasswordModal" onHide={() => this.context.toggleModal(false)}>
				<h1>Sæt dit kodeord</h1>
				<ValidateForm onSubmit={this.submit}>
					<FormInput password name="password" req/>
					<Button submit>Gem</Button>
				</ValidateForm>
			</Modal>
		)
	}
}
export const FirstLogin = reduxWrapper("getApiCall")(FirstLoginRender);



// WEBPACK FOOTER //
// ./src/components/structure.js